var $4742231a685fa068$exports = {};
$4742231a685fa068$exports = {
    "alpha": `Alfa`,
    "blue": `Plava`,
    "brightness": `Svjetlina`,
    "green": `Zelena`,
    "hue": `Nijansa`,
    "lightness": `Osvijetljenost`,
    "red": `Crvena`,
    "saturation": `Zasi\u{107}enost`
};


export {$4742231a685fa068$exports as default};
//# sourceMappingURL=hr-HR.module.js.map
